<template>
  <div class="new-email">
    <h3>{{ $t('profile.newEmail.title') }}</h3>
    <el-form
      :model="form"
      :rules="rules"
      @submit.native.prevent="submit"
      ref="form">
      <el-form-item :label="$t('profile.newEmail.email.text')" props="email">
        <el-input
          v-model="form.email"
          :placeholder="$t('profile.newEmail.email.text')"
          autofocus
          suffix-icon="el-icon-message">
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('profile.newEmail.password.text')" props="password">
        <el-input
          v-model="form.password"
          :placeholder="$t('profile.newEmail.password.text')"
          show-password
          suffix-icon="el-icon-lock">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="isUpdateEmailLoading"
          :disabled="isUpdateEmailLoading"
          native-type="submit"
          type="primary">
          {{ $t('profile.newEmail.submit') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'newEmail',
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      rules: {
        password: [
          {
            required: true,
            message: this.$t('profile.newEmail.password.warning'),
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            type: 'email',
            message: this.$t('profile.newEmail.email.warning'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      profile: 'profileStore/profile',
      isUpdateEmailLoading: 'profileStore/isUpdateEmailLoading',
    }),
  },
  methods: {
    ...mapActions({
      getProfile: 'profileStore/getProfile',
      updateEmail: 'profileStore/updateEmail',
    }),
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.updateEmail({
            password: this.form.password,
            email: this.form.email,
          }).then(() => {
            this.form.password = '';
          });
        }
      });
    },
  },
  async created() {
    try {
      await this.getProfile();
      this.form.email = this.profile && this.profile.email;
    // eslint-disable-next-line no-empty
    } catch (e) {}
  },
};
</script>
